import React, {Component} from "react";
import {isRegisterCampaign} from "../../lib/user";
import DataGrid from "./component/Datagrid";
import firebase, {config} from "../../lib/firebase";
import MarkDialog from "./component/MarkDialog";
import Menu from "./component/Menu";
import LoginDialog from "../Auth/LoginDialog";
import _ from "lodash";
import ViewDialog from "./component/ViewDialog";
import Nobody from "./component/Nobody";
import async from "async";
import CircularProgress from "material-ui/CircularProgress";
import "./Campaign.css";
import LiveDialog from "./component/LiveDialog.js";
import store from "../../lib/store";
import IconButton from 'material-ui/IconButton';
import ActionHome from 'material-ui/svg-icons/action/home';
import User from "../user/User";
import Status from "../user/Status";

require('es6-promise').polyfill();
window._ = _;
class Campaign extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLogined : null,
            isRegistered : null,
            topics: false,
            users: false,
            nobody:null,
            MarkDialogProps: {
                open: false
            },
            ViewDialogProps:{
                open:false
            },
            userProfileOpen:false,
            progressVisible:{'display':'none'},
            campaignUserLevel:store.getState().isAdmin
        }
        this.campaignId = this.props.match.params.campaignId;
        store.subscribe(function(){
            this.setState({
                campaignUserLevel:store.getState().campaignUserLevel,
                userProfileOpen:store.getState().userProfileOpen,
                statusOpen:store.getState().statusOpen
            });
            if(store.getState().campaignIsNeedInitialize){
                this.fetchInitial();
                store.dispatch({type:'CAMPAIGN_INITIALIZE_OVER'});
            }
        }.bind(this));
        if(this.props.location && this.props.location.hash && this.props.location.hash.indexOf('#comment') === 0){
            store.dispatch({
                type:'OPEN_DISQUS'
            });
        }
        this.unsubscribe = firebase.auth().onAuthStateChanged(function(user){
            if (user === null) {
                return store.dispatch({type:'CAMPAIGN_USER_LEVEL', campaignUserLevel:'NOT_LOGINED'});
            }
            firebase.database().ref(`campaign/${this.campaignId}/users/${user.uid}`).once('value', function (sp) {
                firebase.database().ref(`campaign/${this.campaignId}/info`).once('value').then(function(sp){
                    if(sp.val() !==null && firebase.auth().currentUser.uid === sp.val().userKey){
                        store.dispatch({type:'CAMPAIGN_USER_LEVEL', campaignUserLevel:'ADMIN'});
                    }
                });
                if (sp.exists()) {
                    return store.dispatch({type:'CAMPAIGN_USER_LEVEL', campaignUserLevel:'PARTICIPANT'});
                } else {
                    return store.dispatch({type:'CAMPAIGN_USER_LEVEL', campaignUserLevel:'NOT_PARTICIPANT'});
                }
            }.bind(this));
        }.bind(this))

        this.pageScale = this.getPageScale();
        this.fetchInitial();
    }

    getPageScale() {
        if(!this.props.match.params.pageScale){
            return 40;
        }
        return Math.min(this.props.match.params.pageScale, 100);
    }
    componentWillUnmount() {
        this.unSyncLoginedUser();
    }

    componentDidMount(){
        firebase.auth().onAuthStateChanged(function(user) {
            if(user === null){
                this.setState({isLogined:false});
            } else {
                this.setState({isLogined:true});
            }
            isRegisterCampaign(this.campaignId, function(isRegister, userSp){
                this.setState({isRegistered:isRegister});
            }.bind(this));
        }.bind(this));
        this.setState({'progressVisible':'block'});
    }

    fetchInitial(){
        let asyncFuncs = [
            this.fetchTopics.bind(this),
            this.fetchUsers.bind(this),
            this.fetchMates.bind(this),
            // this.fetchLoginedUser.bind(this),
            this.fetchInfo.bind(this)
        ];

        async.parallel(asyncFuncs, function(error, data){

            let info = _.find(data, {type:'info'});
            if(!info.data){
                this.setState({nobody:true});
                this.setState({'progressVisible':'none'});
                return false;
            }

            if(info.data.title)
                window.document.querySelector('title').innerHTML = info.data.title;


            let topics = _.find(data, {type:'topics'})['data'];
            topics = Campaign.objectify(topics);
            topics.sort(function (o1, o2) {
                return o1.order - o2.order;
            });
            topics = topics.filter(function(e){
                if(e.title && e.order)
                    return true;
                else
                    return false;
            });


            let tempUser = _.find(data, {type:'users'})['data'];
            tempUser = Campaign.objectify(tempUser);
            let users = [];
            for (let i = 0; i < tempUser.length; i++) {
                let user = tempUser[i];
                users.push(Campaign.userify(user, topics));
            }
            users.sort(function (o1, o2) {
                return o2.updated - o1.updated;
            });

            /*let loginedUserSp = _.find(data, {type:'loginedUser'})['data'];
            if(loginedUserSp){
                let loginedUser = Campaign.userify(_.extend(loginedUserSp.val(), {key:loginedUserSp.key}), topics);
                let index = _.findIndex(users, ['key', loginedUser.key]);
                if(index !== -1){
                    users.splice(index, 1);
                }
                users.unshift(loginedUser);
            }*/

            let tempMates = _.find(data, {type:'mates'})['data'];
            tempMates = Campaign.objectify(tempMates);
            let mates = [];
            for (let i = 0; i < tempMates.length; i++) {
                let mate = tempMates[i];
                mates.push(Campaign.userify(mate, topics));
            }
            mates.sort(function (o1, o2) {
                return o2.updated - o1.updated;
            });

            users = _.filter(users, function(e){
                for(var j=0; j<mates.length; j++){
                    if(mates[j].key === e.key)
                        return false;
                }
                return true;
            });

            for(var j=0; j<mates.length; j++){
                users.splice(j,0,mates[j]);
            }

            for(var k=0; k<users.length; k++){
                if(users[k].isLoginedUser){
                    var user = users.splice(k,1);
                    users.unshift(user[0]);
                    break;
                }
            }

            this.setState({
                topics: topics,
                users: users
            }, function(){
                this.syncLoginedUser();
                this.setState({'progressVisible':'none'});
            }.bind(this));

        }.bind(this));
    }

    fetchInfo(callback){
        firebase.database().ref(`campaign/${this.campaignId}/info`).once('value').then(function(sp){
            callback(null, {type:'info', data:sp.val()});
        });
    }

    fetchTopics(callback) {
        firebase.database().ref(`campaign/${this.campaignId}/topics`).once('value').then(function(sp){
            callback(null, {type:'topics', data:sp.val()});
        });
    }

    /*fetchUsers(callback) {
        firebase.database().ref(`campaign/${this.campaignId}/users`).orderByChild('info/updated').limitToLast(20).once('value').then(function(sp){
            callback(null, {type:'users', data:sp.val()});
        })
    }*/

    fetchMates(callback){
        firebase.auth().onAuthStateChanged(function(callback, user){
            if(user !== null){
                fetch(`${config.firebase.functionURL}/campaignmate?campaign_id=${this.campaignId}&me=${firebase.auth().currentUser.uid}`).then(res => {
                    return res.json();
                }).then(function (result) {
                    callback(null, {type:'mates', data:result});
                });
            } else {
                callback(null, {type:'mates', data:{}});
            }
        }.bind(this, callback));
    }

    fetchUsers(callback) {
        firebase.auth().onAuthStateChanged(function(callback, user) {
            var loginedUserAux = '';
            if(user !== null){
                loginedUserAux = `&loginedUser=${user.uid}`;
            }
            fetch(`${config.firebase.functionURL}/campaignuser/?id=${this.campaignId}&pageScale=${this.pageScale}${loginedUserAux}`).then(res => {
                //fetch(`${config.firebase.functionURL}/campaignuser?id=${this.campaignId}`).then(res => {
                return res.json();
            }).then(function (result) {
                callback(null, {type:'users', data:result});
            });
        }.bind(this, callback));
    }

    fetchLoginedUser(callback){
        isRegisterCampaign(this.campaignId, function(isRegister, userSp){
            if(isRegister){
                callback(null, {type:'loginedUser', data:userSp});
            } else {
                callback(null, {type:'loginedUser', data:null});
            }
        });
    }

    // 실시간으로 자신의 수정 사항이 변경되도록 하기 위한 기능
    syncLoginedUser() {
        if(!firebase.auth().currentUser)
            return false;
        let uid = firebase.auth().currentUser.uid;
        firebase.database().ref(`campaign/${this.campaignId}/users/${uid}`).on('value', function (sp) {
            if(!sp.val()){
                return null;
            }
            let user = Campaign.userify(_.extend(sp.val(), {key:sp.key}), this.state.topics);
            let newUsers = this.state.users.map(function(e){
                if(user.key === e.key){
                    user.name = e.name;
                    user.photoURL = e.photoURL;
                    return user;
                }
                return e;
            });
            this.setState({users:newUsers});

        }.bind(this));
    }

    unSyncLoginedUser() {
        let uid = firebase.auth().currentUser.uid;
        firebase.database().ref(`campaign/${this.campaignId}/users/${uid}`).off();
    }

    static userify(user, topics) {
        let statuses = {};
        for (let j = 0; j < topics.length; j++) {
            let topicKey = topics[j].key;
            if (!user.datas || !user.datas[topicKey]) {
                statuses[topicKey] = {status: 0, msg: '', key: topicKey, photoURL:''};
                continue;
            }
            let usersDatas = Object.assign({}, user.datas[topicKey], {key: topicKey});
            statuses[topicKey] = usersDatas;
        }
        return {
            key: user.key,
            name: user.info.displayName,
            isMate: user.info.isMate ? true : false,
            isLoginedUser: user.isLoginedUser ? true : false,
            updated: user.info.updated,
            photoURL: user.info.photoURL,
            statuses: statuses
        };
    }

    static objectify(target) {
        var collector = []
        for (var name in target) {
            collector.push(Object.assign({}, target[name], {key: name}));
        }
        return collector;
    }

    dataGridClickHandler(event, status, user) {
        if(firebase.auth().currentUser && firebase.auth().currentUser.uid === user.key){
            this.setState({
                MarkDialogProps: {
                    open: true,
                    msg: status.msg,
                    status: status.status,
                    key: status.key,
                    userKey: user.key
                }
            });
        } else {
            if(status.msg !== ''){
                // store.dispatch({type:'STATUS_OPEN', statusId:status.key});
                this.setState({
                    ViewDialogProps: {
                        open: true,
                        msg: status.msg,
                        status: status.status,
                        key: status.key,
                        userKey: user.key,
                        campaignId : this.campaignId
                    }
                });
            }
        }
    }



    render(){
        let content;
        var userProfile, status = null;
        if(this.state.userProfileOpen){
            userProfile = <User id={store.getState().userProfileId}></User>;
        }
        if(this.state.statusOpen){
            status = <Status id={store.getState().statusId}></Status>;
        }
        if(!this.state.nobody === null){
            content = <div></div>;
        } else if(this.state.nobody){
            content = <Nobody campaignId={this.props.match.params.campaignId} />;
        } else {

            let viewDialog = null;
            if(this.state.ViewDialogProps.open){
                viewDialog = <ViewDialog dialogProps={this.state.ViewDialogProps} onSubmit={function (data) {
                    this.setState({ViewDialogProps:{open:false}});
                }.bind(this)} onCloseRequest={function(){
                    this.setState({ViewDialogProps:{open:false}});
                }.bind(this)}/>
            }

            content = (
                <div className="Campaign">
                    <DataGrid onClickCell={this.dataGridClickHandler.bind(this)} topics={this.state.topics}
                              users={this.state.users}/>
                    <MarkDialog dialogProps={this.state.MarkDialogProps}
                                onSubmit={function (data) {
                                    let base = `campaign/${this.campaignId}/users/${data.userKey}`;
                                    firebase.database().ref(`${base}/datas/${data.key}`).set({msg: data.msg, status: data.status, updated:firebase.database.ServerValue.TIMESTAMP});
                                    firebase.database().ref(`${base}/info/updated`).set(firebase.database.ServerValue.TIMESTAMP);
                                    this.setState({MarkDialogProps:{open:false}});
                                    window.ga('send', 'event', 'complete', data.status === 1 ? 'yes' : 'no', data.status === 1 ? '봤어요' : '안봤어요');
                                }.bind(this)}
                                onCloseRequest={function(){
                                    this.setState({MarkDialogProps:{open:false}});
                                }.bind(this)}
                    />
                    {viewDialog}
                    <CircularProgress className="progress" style={{'display':this.state.progressVisible}}/>
                </div>

            );
        }
        return (
            <div>
                <IconButton
                    style={{
                        position:'absolute',
                        zIndex:1000
                    }}
                    href="/"
                >
                    <ActionHome />
                </IconButton>
                {userProfile}
                {status}
                {content}
                <LoginDialog></LoginDialog>
                <LiveDialog
                    campaignId={this.campaignId}
                />
                <Menu
                    campaignId={this.campaignId}
                    isLogined={this.state.isLogined}
                    isRegistered={this.state.isRegistered}
                />
            </div>
        );
    }
}

export default Campaign;


// WEBPACK FOOTER //
// ./src/container/campaign/Campaign.js